import type { BillItemTemplate } from '@/types/composition-functions';
import { useCreateBillItemTemplateMutation, GetBillItemTemplatesDocument } from '@/types/vue-apollo-helpers';

export const useCreateBillItems = () => {
  const { mutate: createBillItem, onDone, onError, loading: isSubmitting } = useCreateBillItemTemplateMutation({
    update: (cache, { data }) => {
      if (data?.createBillItemTemplate) {
        const existingData = cache.readQuery<{ billItemTemplates: BillItemTemplate[] }>({
          query: GetBillItemTemplatesDocument,
        });
        if (existingData && existingData.billItemTemplates) {
          const newBillItems = [...existingData.billItemTemplates, data.createBillItemTemplate];
          cache.writeQuery({
            query: GetBillItemTemplatesDocument,
            data: { billItemTemplates: newBillItems },
          });
        }
      }
    },
  });
  return {
    createBillItem,
    onDone,
    onError,
    isSubmitting,
  };
};
